import { updateViewI18n } from "../i18n";

const MAP_MARKER = {
    'Default': 'symbols/project/地图图标/default.json',
    'Project': 'symbols/smart-park/map/项目点.json',
    'Rent': 'symbols/smart-park/map/租赁.json',
    'Ad': 'symbols/smart-park/map/广告位.json',
    'Parking': 'symbols/smart-park/map/停车场.json',
    'Organization': 'symbols/smart-park/map/服务机构.json',
    'Building': 'symbols/smart-park/map/楼宇.json',
    'Population': 'symbols/smart-park/map/人口进出.json',
    'Revenue': 'symbols/smart-park/map/营业额.json',
    'Enterprise': 'symbols/smart-park/map/重点企业.json',
};
const SYSTEM_CONFIG = htconfig.CustomConfig;

export default class PointLayer {
    constructor(map, data, layerName, options = {}) {
        this.map = map;
        this.data = data;
        this.options = options;
        this.layerName = layerName;
        this.nodeRender = options.nodeRender || 'GIS_HT',
        this.size = options.size || SYSTEM_CONFIG.iconSize || [30, 70, 30];
        this.nodes = [];
        this.init();
    }

    /**
     * 图层初始化处理
     */
    init() {
        const {
            map,
            data,
            options,
            layerName
        } = this;

        data.forEach((info, i) => {
            const node = createPoint({
                id: info.id, 
                lnglat: [info.lng, info.lat],
                layerName: layerName,
                height: info.height || options.height || 2,
                scale: options.scale || 1,
                nodeRender: options.nodeRender || 'GIS_HT',
            });
            node.setTag(`${layerName}-${info.id}`);
            node.a('properties', info);
            map.add(node);
            this.handlerNode(node, info);
            this.nodes.push(node);
        });
        updateViewI18n(map.graph3dView);
        
    }

    /**
     * 处理节点数据（子类重写该方法）
     * @param {*} node 
     * @param {*} info 
     */
    handlerNode(node, info) {

    }

    /**
     * 移除
     */
    remove() {
        const {
            nodes
        } = this;
        nodes.forEach(node => {
            node.remove();
        });
    }

    /**
     * 显示数据
     */
    show() {
        const nodes = this.nodes;

        nodes.forEach(node => {
            node.s({
                '3d.visible': true,
                'shape3d.opacity': 0
            });
        });
        this.showAnim = ht.Default.startAnim({
            duration: 1000,
            easing: t => t,
            action: v => {
                nodes.forEach(node => {
                    node.s('shape3d.opacity', v);
                });
            },
            finishFunc: () => {
                if(this.showAnim) {
                    this.showAnim.pause();
                    this.showAnim = null;
                }
            }
        });
    }

    /**
     * 隐藏数据
     */
    hide() {
        if(this.showAnim) {
            this.showAnim.pause();
            this.showAnim = null;
        }
        this.nodes.forEach(node => {
            node.s('3d.visible', false);
        });
    }
}

function createPoint(options = {}) {
    const point = new ht.cesium.Node({
        id: options.id,
        lnglat: options.lnglat,
        height: options.height,
        scale: options.scale,
        nodeRender: options.nodeRender,
    });
    point.s({
        'interactive': true,
        '2d.selectable': true,
        '3d.selectable': true,
        '2d.movable': false,
        '2d.visible': true,
        '3d.movable': false,
        '3d.visible': true,
        'shape3d': 'billboard',
        'shape3d.autorotate': true,
        'shape3d.fixSizeOnScreen': SYSTEM_CONFIG.fixSizeOnScreen,
        'shape3d.vector.dynamic': true,
        'shape3d.image': MAP_MARKER[options.layerName] || MAP_MARKER.Default,
        'shape3d.reverse.cull': true,
        'shape3d.transparent': true,
        'texture.cache': false,
        'wf.visible': false,
    });
    return point;
}